import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SickIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sick"}/>
}
